import { types } from 'mobx-state-tree';
import { loadable as makeLoadable } from '../loadable/loadable';
import { fetchParking } from './fetchParkings';
import {
  HeightRestrictions,
  Times,
  GeometryData,
  DynamicProperties,
  Address,
  RateTable,
  optionalMaybeNull,
} from './parkopediaTypes';

export const StaticProperties = types.model('StaticProperties', {
  additional_info: optionalMaybeNull(types.string),
  address: optionalMaybeNull(Address),
  height: optionalMaybeNull(HeightRestrictions),
  name: optionalMaybeNull(types.string),
  capacity: types.optional(types.number, 0),
  operator: optionalMaybeNull(types.string),
  orientation: optionalMaybeNull(types.string),
  payment_method: optionalMaybeNull(types.string),
  payment_types: types.array(types.string),
  phone: optionalMaybeNull(types.string),
  surface_type: optionalMaybeNull(types.string),
  type: optionalMaybeNull(types.string),
  url: optionalMaybeNull(types.string),
  rate_tables: optionalMaybeNull(RateTable),
  times: optionalMaybeNull(Times),
});

const Properties = types.model('Properties', {
  dynamic: types.maybeNull(DynamicProperties),
  static: StaticProperties,
});

const ParkingSpot = types.model('ParkingSpot', {
  type: types.string,
  geometry: types.maybeNull(GeometryData),
  properties: types.maybe(Properties),
});

export const MobxParkopediaStore = types
  .model({
    parkingSpots: makeLoadable(types.array(ParkingSpot), fetchParking),
  })
  .actions((self) => ({
    setStoreEmpty: () => (self.parkingSpots.data = []),
  }));
